<template>
  <div>
    <div class="flex">
      <ScreenSizePicker
        @tablet="tabletSize"
        @mobile="mobileSize"
        @desktop="desktopSize"
      />
      <button
        v-if="hasChanges"
        class="text-gray-700 hover:text-gray-900 rounded p-1 ml-auto uppercase"
        @click="resetAll"
      >
        Reset All
        <FontAwesomeIcon icon="undo" />
      </button>
      <button
        v-if="$store.state.canvasImage"
        class="text-gray-700 hover:text-gray-900 rounded p-1 ml-2 uppercase"
        @click="resetImagePosition"
      >
        Reset Image
        <FontAwesomeIcon icon="image" />
      </button>
      <button
        :class="
          hasChanges
            ? 'text-gray-700 hover:text-gray-900 rounded p-1 ml-2 uppercase'
            : 'text-gray-700 hover:text-gray-900 rounded p-1 ml-auto uppercase'
        "
        @click="saveImage"
      >
        Export
        <FontAwesomeIcon icon="file-download" />
      </button>
    </div>
    <div
      id="stage-parent"
      :class="stageContainer"
    >
      <v-stage
        ref="stage"
        :config="stageSize"
      >
        <v-layer ref="imglayer">
          <v-image
            ref="canvasImage"
            :config="configImg"
            draggable="true"
          />
        </v-layer>
        <v-layer ref="textlayer">
          <v-text
            ref="text"
            :config="textConfig"
            @dragend="handleDragEnd"
            @dragstart="handleDragStart"
          />
        </v-layer>
        <v-layer ref="headerlayer">
          <v-text
            ref="headertext"
            :config="headerTextConfig"
            @dragend="handleDragEnd"
            @dragstart="handleDragStart"
          />
        </v-layer>
        <v-layer
          v-if="$store.state.buttonText"
          ref="buttonlayer"
          draggable="true"
        >
          <v-rect
            ref="buttonshape"
            :config="{
              x: 20,
              y: 60,
              stroke: '#555',
              strokeWidth: 1,
              fill: $store.state.selectedButtonValues.buttonColor,
              rx: 4,
              width: $store.state.buttonSizeWidth,
              height: $store.state.buttonSizeHeight,
              shadowColor: 'black',
              shadowBlur: 10,
              shadowOffsetX: 10,
              shadowOffsetY: 10,
              shadowOpacity: 0.2,
              cornerRadius: 4
            }"
          />
          <v-text
            ref="buttontext"
            :config="buttonTextConfig"
          />
        </v-layer>
      </v-stage>
    </div>
    <ControlPanel @button-status="handleButtonToggle" />
  </div>
</template>
<script>
import ControlPanel from '@/components/ControlPanel.vue'
import ScreenSizePicker from '@/components/ScreenSizePicker.vue'

export default {
  name: 'HeroCreator',
  components: {
    ControlPanel,
    ScreenSizePicker
  },
  props: {},
  data() {
    return {
      stageSize: {
        width: 2850,
        height: 1000
      },
      isDragging: false,
      buttonIsActive: false,
      stageContainer: 'border mb-4',
      stage: null,
      container: null
    }
  },
  computed: {
    configImg: function() {
      return {
        image: this.$store.state.canvasImage,
        x: 0,
        y: 0
      }
    },
    headerTextConfig() {
      const intensity = this.$store.state.selectedHeaderFontValues
        .shadowIntensity
      const shadowBlur = intensity * 2
      const shadowOpacity = intensity / 10
      const shadowOffset = intensity
      const base = {
        text: this.$store.state.headerText,
        fontSize: this.$store.state.selectedHeaderFontValues.fontSize,
        fontFamily: this.$store.state.selectedHeaderFontValues.fontFamily,
        fontStyle: this.$store.state.selectedHeaderFontValues.fontStyle,
        x: 200,
        y: 200,
        draggable: true,
        fill: this.isDragging
          ? 'green'
          : this.$store.state.selectedHeaderFontValues.fontColor,
        shadowColor: 'black',
        shadowBlur: intensity === 0 ? 0 : shadowBlur,
        shadowOffsetX: intensity === 0 ? 0 : shadowOffset,
        shadowOffsetY: intensity === 0 ? 0 : shadowOffset,
        shadowOpacity: intensity === 0 ? 0 : shadowOpacity
      }
      return base
    },
    textConfig() {
      const intensity = this.$store.state.selectedTextFontValues.shadowIntensity
      const shadowBlur = intensity * 2
      const shadowOpacity = intensity / 10
      const shadowOffset = intensity
      const base = {
        text: this.$store.state.bodyText,
        fontSize: this.$store.state.selectedTextFontValues.fontSize,
        fontFamily: this.$store.state.selectedTextFontValues.fontFamily,
        fontStyle: this.$store.state.selectedTextFontValues.fontStyle,
        x: 200,
        y: 250,
        draggable: true,
        fill: this.isDragging
          ? 'green'
          : this.$store.state.selectedTextFontValues.fontColor,
        shadowColor: 'black',
        shadowBlur: intensity === 0 ? 0 : shadowBlur,
        shadowOffsetX: intensity === 0 ? 0 : shadowOffset,
        shadowOffsetY: intensity === 0 ? 0 : shadowOffset,
        shadowOpacity: intensity === 0 ? 0 : shadowOpacity
      }
      return base
    },
    buttonTextConfig() {
      return {
        x: 20,
        y: 60,
        text: this.$store.state.buttonText,
        fontSize:
          (this.$store.state.buttonSizeWidth +
            this.$store.state.buttonSizeHeight) /
          10,
        fontFamily: this.$store.state.selectedButtonValues.fontFamily,
        fontStyle: this.$store.state.selectedButtonValues.fontStyle,
        width: this.$store.state.buttonSizeWidth,
        align: 'center',
        fill: this.$store.state.selectedButtonValues.fontColor,
        padding: this.$store.state.buttonSizeHeight / 3.5
      }
    },
    hasChanges() {
      return (
        this.$store.state.headerChangeCounter > 0 ||
        this.$store.state.textChangeCounter > 0 ||
        this.$store.state.buttonChangeCounter > 0 ||
        this.$store.state.headerText !== '' ||
        this.$store.state.bodyText !== '' ||
        this.$store.state.buttonText !== '' ||
        this.$store.state.canvasImage !== null
      )
    }
  },

  mounted() {
    this.stage = this.$refs.stage.getStage()
    this.container = document.querySelector('#stage-parent')
    this.$store.commit('handleImageSizeChange', 'desktop')
    this.fitStageIntoParentContainer()
    this.$nextTick(function() {
      window.addEventListener('resize', this.fitStageIntoParentContainer)
    })
  },

  methods: {
    handleDragStart() {
      this.isDragging = true
    },
    handleDragEnd() {
      this.isDragging = false
    },
    handleButtonToggle(value) {
      this.buttonIsActive = value
    },
    desktopSize(val) {
      this.stageSize = {
        width: 2850,
        height: 1000
      }
      this.resetNodePositions()
      this.$store.commit('handleImageSizeChange', val)
      this.stageContainer = 'border mb-4'
      this.$nextTick(function() {
        this.fitStageIntoParentContainer()
      })
    },
    tabletSize(val) {
      this.stageSize = {
        width: 1535,
        height: 1000
      }
      this.resetNodePositions()
      this.$store.commit('handleImageSizeChange', val)
      this.stageContainer = 'border mb-4'
      this.$nextTick(function() {
        this.fitStageIntoParentContainer()
      })
    },
    mobileSize(val) {
      this.stageSize = {
        width: 750,
        height: 500
      }
      this.resetNodePositions()
      this.$store.commit('handleImageSizeChange', val)
      this.stageContainer = 'border lg:w-4/5 mx-auto mb-4'
      this.$nextTick(function() {
        this.fitStageIntoParentContainer()
      })
    },

    //Den här är helt kaos: ändrar skalan och stage:n till originalstorlek, exporterar bild och ändrar tillbaks. Finns förbättringspotential.
    saveImage() {
      const stage = this.$refs.stage.getStage() //Refererar canvasen
      stage.scale({ x: 1, y: 1 }) //Sätter skalan till 1:1
      stage.width(this.stageSize.width) //Sätter bredden till original
      stage.height(this.stageSize.height) //Sätter Höjden till original
      const anchor = document.createElement('a') //Skapar länkelementet
      anchor.href = stage.toDataURL() //Pekar länken till dataurl:en
      anchor.download = 'myhero.png' //Bildnamn och format som ska laddas ner
      anchor.click() //Klickar länken
      let container = document.querySelector('#stage-parent') //Hämtar canvasen:s wrapper-element
      let containerWidth = container.offsetWidth - 2 //Hämtar wrapper-elementets offsetwidth (-2px för att passa inom border)
      let scale = containerWidth / this.stageSize.width //Definierar skalan
      stage.width(this.stageSize.width * scale) //Sätter bredd efter den definierade skalan
      stage.height(this.stageSize.height * scale) //Sätter Höjd efter den definierade skalan
      stage.scale({ x: scale, y: scale }) //Sätter skalan på canvasen
      stage.draw() //Ritar canvasen
    },
    clearStage() {
      this.$refs.stage.getStage().clear()
      this.draggableText = ''
      this.draggableText2 = ''
      this.$store.commit('clearImageUrl')
    },
    fitStageIntoParentContainer() {
      let stage = this.stage
      let container = this.container
      let containerWidth = container.offsetWidth - 2
      let scale = containerWidth / this.stageSize.width

      stage.width(this.stageSize.width * scale)
      stage.height(this.stageSize.height * scale)
      stage.scale({ x: scale, y: scale })
      stage.draw()
    },
    resetNodePositions() {
      this.$refs.text.getNode().position({ x: 200, y: 250 })
      this.$refs.headertext.getNode().position({ x: 200, y: 200 })
      if (this.$refs.buttonlayer) {
        this.$refs.buttonlayer.getNode().position({ x: 50, y: 250 })
      }
      if (this.$refs.canvasImage) {
        this.$refs.canvasImage.getNode().position({ x: 0, y: 0 })
      }
    },
    resetAll() {
      this.$store.commit('resetAllToDefaults')
      this.$nextTick(() => {
        this.resetNodePositions()
      })
    },
    resetImagePosition() {
      if (this.$refs.canvasImage) {
        this.$refs.canvasImage.getNode().position({ x: 0, y: 0 })
      }
    }
  }
}
</script>

<style scoped></style>
